import { infoIcon } from '../styles';
import { IconLegendTooltipComponent } from './custom-renderer/icon-legend-tooltip-component';
import { ITooltipComp } from '@ag-grid-community/core';
import { CreditProfileLegendTooltipComponent } from './custom-renderer/credit-profile-legend-tooltip-component';

export function getGroupColumnSameValue(params: any, column: string): string {
  if (params.data && params.data[column]) {
    return params.data[column];
  }
  if (params.node && params.node.allLeafChildren) {
    return params.node.allLeafChildren[0].data[column];
  }
  return '';
}

export function getGroupColumnSameObject(params: any, column: string): any {
  if (params.data && params.data[column]) {
    return params.data[column];
  }
  if (params.node && params.node.allLeafChildren) {
    return params.node.allLeafChildren[0].data[column];
  }

  return '';
}

export function getGroupColumnContractType(params: any, column: string): any {
  if (params.data && params.data[column]) {
    return params.data[column];
  }
  if (params.node && params.node.allLeafChildren) {
    return params.node.allLeafChildren[0].data[column];
  }
  if (params.node) {
    return params.node.data;
  }
  return '';
}

export function getGroupColumnSameObjectImpliedPrice(params: any, column: string): any {
  if (params.data && params.data[column]) {
    return params.data[column];
  }
  if (params.node && params.node.allLeafChildren) {
    return params.node.allLeafChildren[0].data[column];
  }
  if (params.node) {
    return params.node.data;
  }
  return '';
}

export function getGroupColumnSameObjectForBuyerLowerBoundPrice(params: any, column: string): any {
  if (params.data && params.data[column].FIXED_PRICE_LOWER_BOUND) {
    return params.data[column];
  }
  if (params.node && params.node.allLeafChildren) {
    return params.node.allLeafChildren[0].data[column].FIXED_PRICE_LOWER_BOUND;
  }
  if (params.node) {
    return params.node.data.FIXED_PRICE_LOWER_BOUND;
  }
  return '';
}

export function getGroupColumnSameObjectForVolume(params: any, column: string): any {
  if (params.data && params.data[column]) {
    return params.data[column].OFFERED_CAPACITY;
  }
  if (params.node && params.node.allLeafChildren) {
    return params.node.allLeafChildren[0].data[column].OFFERED_CAPACITY;
  }

  if (params.node) {
    return params.node.data.VOLUME;
  }
  return '';
}

export function getGroupColumnSameObjectForActions(params: any, column: string): any {
  if (params.data && params.data[column]) {
    return params.data[column].NEGOTIATION_STATUS;
  }
  if (params.node && params.node.allLeafChildren) {
    return params.node.allLeafChildren[0].data[column].NEGOTIATION_STATUS;
  }
  if (params.node) {
    return params.node.data.NEGOTIATION_STATUS;
  }
  return '';
}

export function getGroupColumnSameObjectForProjectName(params: any, column: string): any {
  if (params.data && params.data[column]) {
    return params.data[column].NAME;
  }
  if (params.node && params.node.allLeafChildren) {
    return params.node.allLeafChildren[0].data[column].NAME;
  }
  if (params.node) {
    return params.node.data.NAME;
  }
  return '';
}

export function getGroupValueForVPPAOrRFQ(params: any, column: string): any {
  if (params.data && params.data[column]) {
    return params.data[column];
  }
  if (params.node && params.node.allLeafChildren) {
    return params.node.allLeafChildren[0].data[column];
  }
  if (params.node) {
    return params.node.data[column];
  }
  return '';
}

export function isCheckboxVisible(params: any, isHeader: boolean): boolean {
  if ((isHeader && !params.data) || (!isHeader && params.data)) {
    return true;
  }
  return false;
}

export function filterNumericRange([fv1, fv2], cellValue: number[]): boolean {
  const lowerBound = cellValue[0];
  const upperBound = cellValue[1];

  return lowerBound >= fv1 && upperBound <= fv2;
}

export function filterLessOrEqualNumberic(fv1, cellValue: number[]): boolean {
  const upperBound = cellValue[1];
  return fv1 >= upperBound;
}

export function filterGreaterOrEqualNumberic(fv1, cellValue: number[]): boolean {
  const lowerBound = cellValue[0];
  return fv1 <= lowerBound;
}

export function filterEqualNumberic(fv1, cellValue: number[]): boolean {
  const lowerBound = cellValue[0];
  const upperBound = cellValue[1];
  return fv1 == lowerBound || fv1 == upperBound;
}

export function compareVPPAValues(
  valueA: any,
  valueB: any,
  nodeA: any,
  nodeB: any,
  vppaProperty: string,
  dataProperty: string,
) {
  let valA = valueA;
  let valB = valueB;

  if (nodeA) {
    if (nodeA.data) {
      valA = nodeA.data.VPPA_OBJECT
        ? nodeA.data.VPPA_OBJECT[vppaProperty]
        : nodeA.data[dataProperty];
    } else {
      valA = nodeA.allLeafChildren[0].data.VPPA_OBJECT[vppaProperty];
    }
  }

  if (nodeB) {
    if (nodeB.data) {
      valB = nodeB.data.VPPA_OBJECT
        ? nodeB.data.VPPA_OBJECT[vppaProperty]
        : nodeB.data[dataProperty];
    } else {
      valB = nodeB.allLeafChildren[0].data.VPPA_OBJECT[vppaProperty];
    }
  }

  if (valA === valB) {
    return 0;
  } else {
    return valA > valB ? 1 : -1;
  }
}

export function compareRFQValues(
  valueA: any,
  valueB: any,
  nodeA: any,
  nodeB: any,
  rfqProperty: string,
  dataProperty: string,
) {
  let valA = valueA;
  let valB = valueB;
  if (nodeA) {
    if (nodeA.data) {
      valA = nodeA.data.RFQ_OBJECT ? nodeA.data.RFQ_OBJECT[rfqProperty] : nodeA.data[dataProperty];
    } else {
      valA = nodeA.allLeafChildren[0].data.RFQ_OBJECT[rfqProperty];
    }
  }

  if (nodeB) {
    if (nodeB.data) {
      valB = nodeB.data.RFQ_OBJECT ? nodeB.data.RFQ_OBJECT[rfqProperty] : nodeB.data[dataProperty];
    } else {
      valB = nodeB.allLeafChildren[0].data.RFQ_OBJECT[rfqProperty];
    }
  }

  if (valA === valB) {
    return 0;
  } else {
    return valA > valB ? 1 : -1;
  }
}

// AG Grid Default Column Header Template (with added info icon after the column header)
const HeaderWithTooltipTemplate =
  '<div class="ag-cell-label-container" role="presentation">' +
  '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
  '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
  '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
  '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
  '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
  '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
  `    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span> <div style="margin-left: 4px" width="16px" height="16px">${infoIcon('start', '14px', '14px')}</div> ` +
  '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
  '  </div>' +
  '</div>';

export const CUSTOM_HEADER_TOOLTIPS = {
  CREDIT_PROFILE: CreditProfileLegendTooltipComponent,
  ICON_LEGEND: IconLegendTooltipComponent,
};

/** For the Custom Header with a Tooltip Icon
 *
 * header tooltip: need to set headerTooltip to something. It will not appear if an empty string.
 * headerComponentParams: use header template, which adds the info icon to the header
 * tooltipComponent: set to our component to render our custom tooltip
 */

export function headerWithTooltipColParams(tooltipComponent?: any) {
  return {
    headerTooltip: 'lorem ipsum',
    headerComponentParams: {
      template: HeaderWithTooltipTemplate,
    },
    tooltipComponent: tooltipComponent,
  };
}
